import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem('pp_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default api;
